import React from 'react'
import { Helmet } from 'react-helmet-async'
import ParseContent from 'components/shared/ParseContent'
import { buildFaqPageJsonLd } from 'utils/faqStructuredData'
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '../elements/Accordion'

export interface FAQProps {
  // eslint-disable-next-line camelcase
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Faq
}

const FAQ: React.FC<FAQProps> = ({ fields }) => {
  const faqJsonLd = buildFaqPageJsonLd(fields.frequentlyAskedQuestion)

  return (
    <>
      {faqJsonLd && (
        // @ts-expect-error react-helmet-async vs duplicate @types/react (styled-components); Helmet is valid at runtime
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(faqJsonLd)}
          </script>
        </Helmet>
      )}
      <section className="py-5">
        <div className="container py-2 py-lg-5">
          <div className="row">
            <div className="col-12 col-lg-8">
              <h2>{fields.title}</h2>
              <Accordion type="single" collapsible className="mt-4">
                {fields.frequentlyAskedQuestion?.map((faq, index) => (
                  <AccordionItem
                    key={faq?.fieldGroupName ?? index}
                    value={String(index)}
                  >
                    <AccordionTrigger>{faq?.question}</AccordionTrigger>
                    <AccordionContent>
                      {faq?.answer && <ParseContent content={faq.answer} />}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default FAQ
